export interface LocaleFormatters {
  date: (value: Date | number | string, options?: Intl.DateTimeFormatOptions) => string;
  time: (value: Date | number | string, options?: Intl.DateTimeFormatOptions) => string;
  number: (value: number, options?: Intl.NumberFormatOptions) => string;
  percentage: (value: number, options?: Intl.NumberFormatOptions) => string;
  currency: (value: number, currency: string) => string;
  relativeTime: (value: number, unit: Intl.RelativeTimeFormatUnit) => string;
  list: (values: readonly string[], options?: Intl.ListFormatOptions) => string;
  languageName: (languageCode: string) => string;
}

function asDate(value: Date | number | string): Date {
  return value instanceof Date ? value : new Date(value);
}

export function createLocaleFormatters(locale: string): LocaleFormatters {
  return {
    date: (value, options = { dateStyle: "medium" }) =>
      new Intl.DateTimeFormat(locale, options).format(asDate(value)),
    time: (value, options = { timeStyle: "short" }) =>
      new Intl.DateTimeFormat(locale, options).format(asDate(value)),
    number: (value, options) => new Intl.NumberFormat(locale, options).format(value),
    percentage: (value, options) =>
      new Intl.NumberFormat(locale, { style: "percent", ...options }).format(value),
    currency: (value, currency) =>
      new Intl.NumberFormat(locale, { style: "currency", currency }).format(value),
    relativeTime: (value, unit) =>
      new Intl.RelativeTimeFormat(locale, { numeric: "auto" }).format(value, unit),
    list: (values, options) => new Intl.ListFormat(locale, options).format(values),
    languageName: (languageCode) =>
      new Intl.DisplayNames([locale], { type: "language" }).of(languageCode) ??
      languageCode,
  };
}
